import { expValEquals, UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

/**
 * JWM Template bundles experiment
 * https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jwm_template_bundles_experiment
 */
// eslint-disable-next-line jira/ff/inline-usage
export const isJwmTemplateBundlesEnabled = () =>
	expValEquals('jwm_template_bundles_experiment', 'cohort', 'variation');

/**
 * JWM Help sample project users create empty projects experiment
 * https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jwm_help_sample_users_create_projects
 */
export const getJwmHelpSampleUsersCreateProjectsCtaType = () => {
	// Intentionally not firing exposure here because it is yet to be determined whether the engagement platform message has started.
	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [expConfig] = UNSAFE_noExposureExp('jwm_help_sample_users_create_projects');
	return expConfig.get('ctaType', 'none');
};
